import { createSlice } from "@reduxjs/toolkit";

const initialCurrency = () => {
  const item = window.localStorage.getItem("currency");
  return item ? item : "USD";
};

const initialLanguage = () => {
  const item = window.localStorage.getItem("language");
  return item ? item : "en";
};

const initialCountry = () => {
  const item = window.localStorage.getItem("countryCode");
  return item ? item : null;
};

const initialState = {
  currency: initialCurrency(),
  language: initialLanguage(),
  countryCode: initialCountry(),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateLanguage: (state, action) => {
      state.language = action.payload;
      window.localStorage.setItem("language", action.payload);
    },
    updateCurrency: (state, action) => {
      state.currency = action.payload;
      window.localStorage.setItem("currency", action.payload);
    },
    updateCountry: (state, action) => {
      state.countryCode = action.payload;
      window.localStorage.setItem("countryCode", action.payload);
    },
  },
});

export const { updateCurrency, updateLanguage, updateCountry } = authSlice.actions;
export const selectAuth = (state) => state.auth;
export default authSlice.reducer;
